/**
 * Native tile coverage of every basemap the map surfaces draw.
 *
 * A fit that zooms past a provider's deepest native level shows upscaled
 * (blurry) or missing (grey) tiles, so every automatic fit clamps to the
 * active basemap's native maximum. Levels read off the served tiles: MML
 * Maastokartta stops adding detail after z16 (z17+ are resampled z16 tiles)
 * and the 0.5 m orthophoto after z17; OpenTopoMap publishes to z17 and the
 * OpenStreetMap standard layer to z19.
 */
export type BasemapProvider = 'maastokartta' | 'ortokuva' | 'osm' | 'opentopomap';

export const BASEMAP_NATIVE_MAX_ZOOM: Readonly<Record<BasemapProvider, number>> = {
  maastokartta: 16,
  ortokuva: 17,
  osm: 19,
  opentopomap: 17,
};

/**
 * The muted style reads the same tiles quieter: overview zooms show many
 * stands at once, where full-colour topography competes with the data drawn
 * over it.
 */
export type BasemapTone = 'standard' | 'muted';
